module.exports = __webpack_public_path__ + "img/plants-8264654_1280.e310d3af.jpg";